import { Observable, OperatorFunction, pipe, UnaryFunction } from "rxjs";
import { filter } from "rxjs/operators";

/**
 * this operator infers that output value is truthy
 */
export function filterFalsy<T>(): UnaryFunction<Observable<T | null | undefined>, Observable<T>> {
    return pipe(filter((value) => !!value) as OperatorFunction<T | null | undefined, T>);
}
